import {
  Button,
  PageHeader,
  TenantDetailTabs,
  useAuth,
  useCall,
} from "@nexys/user-management-web";
import { ChevronLeft } from "lucide-react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

export const TenantDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { hasUserRole, hasTenantRole } = useAuth();
  const tenant = useCall("getFullTenant", { organizationId: id ?? "" });

  // Superadmins always see every tenant; tenant owners/admins can
  // manage their own.
  const canView = hasUserRole("superadmin") || hasTenantRole("owner", "admin", "member");
  const canManage = hasUserRole("superadmin") || hasTenantRole("owner", "admin");
  const canDelete = hasUserRole("superadmin");

  if (!id) return <Navigate to="/tenants" replace />;
  if (!canView) return <Navigate to="/" replace />;

  return (
    <div className="grid gap-6">
      <PageHeader
        title={tenant.data?.name ?? "Tenant"}
        description="Settings, members and roles for this organization."
        actions={
          <Button variant="outline" size="sm" onClick={() => navigate("/tenants")}>
            <ChevronLeft /> Back
          </Button>
        }
      />
      <TenantDetailTabs
        organizationId={id}
        canManage={canManage}
        canDelete={canDelete}
        userPicker={hasUserRole("superadmin", "useradmin")}
        onDeleted={() => navigate("/tenants")}
        onIdChanged={(newId) => navigate(`/tenants/${newId}`, { replace: true })}
      />
    </div>
  );
};
